export let baseUrl = process.env.REACT_APP_BASE_URL;

// export let baseUrl = "http://localhost:9000/api/";

const Apis = {
  baseUrl,
  login: baseUrl + "auth/login",
  users: baseUrl + "user",
  hierarchyUsers: baseUrl + "team/getMyAllTeamMembers",
  leads: baseUrl + "lead",
  leadFollowUpNotification: baseUrl + "lead/notification",
  meeting: baseUrl + "meeting",
  team: baseUrl + "team",
  booking: baseUrl + "booking",
  bookingAdd: baseUrl + "booking/V2",
  developer: baseUrl + "developer",
  // project: baseUrl + "project",
  project: baseUrl + "campaign",
  updateCampaign: (id) => `${baseUrl}campaign/${id}/update`,
  getLeadById: baseUrl + "lead/getLeadById",
  meetingDetailsById: baseUrl + "meeting/meetingDetailsById",

  dashboard: baseUrl + "dashboard",
  leaderboard: baseUrl + "leaderboard",
  meetingDashboard: baseUrl + "dashboard/meetings",
  bookingDashboard: baseUrl + "dashboard/bookings",
  leadQualityDashboard: baseUrl + "dashboard/lead-quality",
  callingQualityDashboard: baseUrl + "dashboard/calling-data-quality",
  leadProjectWiseDashboard: baseUrl + "dashboard/lead-project-wise",
  closingLeadProjectWiseDashboard:
    baseUrl + "dashboard/closing-lead-project-wise",

  getBookingDetailsById: baseUrl + "booking/getBookingDetailsById",
  bookingPayment: baseUrl + "booking/updatePayment",
  getMeetingForBooking: baseUrl + "meeting/getMeetingForBooking",
  assignUsers: baseUrl + "user/assigningUsers",
  developerUpdateById: baseUrl + "developer/developerUpdateById",
  userUpdateById: baseUrl + "user/userUpdateById",
  leadUpdateById: baseUrl + "lead/leadUpdateById/",
  myLeads: baseUrl + "lead/myLeads",
  //Lead Note
  addNote: baseUrl + "lead/addNotes",
  editNote: baseUrl + "lead/notes",
  deleteNote: baseUrl + "lead/notes",
  statusUpdateById: baseUrl + "lead/statusUpdateById/",
  teamUpdatedById: baseUrl + "team/teamUpdateById/",
  leadAssignById: baseUrl + "lead/leadAssignById",
  assignedHistoryById: baseUrl + "lead/getAssignedHistory",
  statusHistoryById: baseUrl + "lead/getStatusHistory",
  updateMeetingById: baseUrl + "meeting/updateMeetingById/",
  deleteMeetingsById: baseUrl + "meeting/deleteMeetingsById",
  bookingApprovedById: baseUrl + "booking/bookingApprovedById",
  bookingRejectedById: baseUrl + "booking/bookingRejectedById",

  deleteLeadsByIds: baseUrl + "lead/deleteLeadsByIds",
  bulkStatusUpdateById: baseUrl + "lead/bulkStatusUpdateById",
  sendToLeadPool: baseUrl + "lead/sendToLeadPool",

  deleteBookingsById: baseUrl + "booking/deleteBookingsById",
  changePassword: baseUrl + "user/changePassword",
  setPassword: baseUrl + "user/setPassword",
  meetingReschedule: baseUrl + "meeting/reScheduleMeetingById",
  meetingAddEntry: baseUrl + "meeting/",
  meetingConduct: baseUrl + "meeting/conductById",
  notificationSeenById: baseUrl + "user/notificationSeenById",
  getNotificationById: baseUrl + "user/getNotificationById",
  getCommissionData: baseUrl + "booking/getCommissionData",
  filterLeads: baseUrl + "lead/filterLeads",
  filterMeetings: baseUrl + "meeting/filterMeetings",
  filterBookings: baseUrl + "booking/filterBookings",
  meetingOtpVerify: baseUrl + "meeting/meetingOtpVerify",
  meetingOtpGenerate: baseUrl + "meeting/meetingOtpGenerate",
  caseFileUpload: baseUrl + "booking/caseFileUpload",
  meetingHistoryById: baseUrl + "meeting/getLatestMeetings",
  topPerformance: baseUrl + "booking/topPerformance",
  summaryOfEOI: baseUrl + "booking/summaryOfConfirmedBusinessBooking",
  topDeveloper: baseUrl + "booking/topDeveloper",
  leadPoolRestriction: baseUrl + "user/updatePoolRestriction",
  inactiveUser: baseUrl + "booking/reportOfInActiveEmployee",
  highlight: baseUrl + "highlight",
  callLogsByUserId: (userId) => `${baseUrl}call-logs/user/${userId}`,
  callLogReportActions: baseUrl + "call-logs/reports/actions",
  //reports
  leadReport: baseUrl + "lead/reports/get-original-assignee",
  reAssignedLeadReport: baseUrl + "lead/reports/get-reassigned-lead",
  specificUserDetailedReport : baseUrl + "user/reports/user-performance",
  /* Hr Management */
  hrmsUser: baseUrl + "hrms/user",
  userAccountStatus: (userId) => `${baseUrl}hrms/user/account-status/${userId}`,
  getTeamBySrManager: baseUrl + "hrms/user/getTeamsBySrManager",
  getAvailableRoles: baseUrl + "hrms/user/getAvailableRoles",
  hrmsLeave: baseUrl + "hrms/leave",
  getHrmsUserDetails: baseUrl + "hrms/user/getUserDetailsById",
  setAdvanceLeaves: baseUrl + "hrms/user/setAdvanceLeaves",
  getHrmsLeaveDetails: baseUrl + "hrms/leave/getDetailsById",
  sendInvitation: baseUrl + "hrms/user/sendInvitation",
  resendUserCredentials: (userId) =>
    `${baseUrl}hrms/user/resendCredentials/${userId}`,
  accessUpdate: baseUrl + "hrms/user/accessUpdate",
  updateUser: baseUrl + "hrms/user/updateUserById",
  hrmsLeaveDasbordData: baseUrl + "hrms/leave/dashboardData",
  hrmsLeaveApprove: baseUrl + "hrms/leave/leaveApproveById",
  hrmsLeaveReject: baseUrl + "hrms/leave/leaveRejectById",
  hrmsUserApprove: baseUrl + "hrms/user/approveById",
  hrmsUserDasbordData: baseUrl + "hrms/user/dashboardData",
  todaysMeetings: baseUrl + "meeting/getTodaysMeetings",
  getDeveloperOptions: baseUrl + "developer/getDeveloperOptions",
  remotePunch: baseUrl + "hrms/att/remotePunch",
  getAttendance: baseUrl + "hrms/att",
  hrmsRaiseIssues: baseUrl + "hrms/att/issueRaiseById",
  getAttDetails: baseUrl + "hrms/att/getDetailsById",
  attUpdateStatus: baseUrl + "hrms/att/updateStatusById",
  hrmsAttApprove: baseUrl + "hrms/att/approve-attendance",
  hrmsGetNotApprovedAtt: baseUrl + "hrms/att/get-notapproved-attendance",

  // HRMS Settings
  getHrmsSettings: baseUrl + "hrms/hrms-settings",
  setApproveAttendanceSetting:
    baseUrl + "hrms/hrms-settings/set-approve-attendance",

  // Attendance Dashboard api
  hrmsDashboard: baseUrl + "hrms/dashboard",
  hrmsLeaveCancel: baseUrl + "hrms/leave/leaveCancelById",

  updateProject: baseUrl + "Project/updateProject",
  deleteProject: baseUrl + "project/deleteProjects",

  //expense cat api
  expanseList: baseUrl + "lead/get-all-category",
  expenseCatList: baseUrl + "lead/getExpenses",
  addExpenseCat: baseUrl + "lead/add-category",
  deleteExpenseCat: baseUrl + "lead/delete-category",
  expenseCatDetails: baseUrl + "lead/get-category",
  expenseCatUpdate: baseUrl + "lead/update-category",

  //expense list api
  addExpenseList: baseUrl + "lead/add-expense",
  deleteExpenseList: baseUrl + "lead/delete-expenses",
  expenseListDetails: baseUrl + "lead/get-expenses",
  updateExpense: baseUrl + "lead/update-expenses",

  //invoice list api
  invoiceList: baseUrl + "lead/getInvoices",
  invoiceDelete: baseUrl + "lead/deleteInvoice",
  invoiceDetails: baseUrl + "lead/getInvoiceById",
  invoiceCreate: baseUrl + "lead/add-invoice",
  invoiceBookingById: baseUrl + "lead/bookings",
  invoiceReceivedById: baseUrl + "lead/uploadReceivedStatus",
  invoiceUpdateById: baseUrl + "lead/updateInvoice",

  //expense team role wise list
  teamRoleExpense: baseUrl + "lead/getUserByRole",

  //lead pool api
  leadPool: baseUrl + "lead/leadPoolList",
  leadPoolClaim: baseUrl + "lead/claimLead",

  //Incentive
  incentive: baseUrl + "incentive/getIncentives",
  incentiveDetails: baseUrl + "incentive/details",
  incentivePayout: baseUrl + "incentive/payIncentive",

  // Confirmed Business
  confirmedBusiness: baseUrl + "booking/confirmedBusinessBooking",
  expressionInterest: baseUrl + "booking/executedBusinessBooking",

  //HRMS User Devices delete
  deleteDevices: baseUrl + "hrms/user/update-devices",
  uploadFile: baseUrl + "media/upload",
  mediaPresign: baseUrl + "media/uploads/presign",
  mediaComplete: (assetId) => `${baseUrl}media/uploads/${assetId}/complete`,
  mediaAccessUrls: baseUrl + "media/access-urls",

  permission: baseUrl + "permission",
  updatePermission: baseUrl + "permission/updatePermission",
  rolePermission: (role) => `${baseUrl}permission/roles/${role}`,
  event: baseUrl + "event",
  getEventById: (id) => `${baseUrl}event/details/${id}`,
  updateEventById: (id) => `${baseUrl}event/${id}`,
  sendEventFeedbackEmails: (id) => `${baseUrl}event/${id}/feedback-emails`,
  deleteEventsByIds: baseUrl + "event/delete",
  deleteInvisByIds: baseUrl + "invitation/delete",
  invitation: baseUrl + "invitation",
  bulkInvitation: baseUrl + "invitation/bulk",
  sendLeadInvitations: baseUrl + "invitation/from-leads",
  invitationStats: baseUrl + "invitation/analytics",
  invitationTopPerformers: baseUrl + "invitation/topPerformers",
  getUnreadReminders: "/user-reminder",
  reminders: baseUrl + "reminders",
  markReminderAsRead: "/user-reminder",
  getUpcomingEvents: "/event/upcomingEventStats",
  hrmsInterview: "/recruitment",
};

export default Apis;
